export const initialValues = {
    result: {},
    isLoading: false,
};
